module.exports = __webpack_public_path__ + "static/media/appointment-paying.b4b2b79e.svg";